var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 2\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-182.6464, -162.2929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2\\u5907\\u4EFD",
    transform: "translate(179, 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 3.6,
    y: 5.3,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy-5\\u5907\\u4EFD-2",
    className: "st1",
    points: "8,15.6 7.3,14.9 11.3,10.9 11.6,10.6 12,10.9 16,14.9 15.3,15.6  11.6,12  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.905f7a33a575b24223917e7768470941.svg";
export { ForwardRef as ReactComponent };